import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { levelMeta } from "../../lib/scoring";
import { ClipboardList, User, Calendar, Code2, FileText, Star, QrCode } from "lucide-react";

const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-2xl border border-slate-200 shadow-card ${className}`}>{children}</div>
);

export default function ExpertDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/expert/interviews").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-ink-soft">Loading…</div>;

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-wider text-brand mb-1">Interview Expert</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-ink">Assigned Interviews</h1>
        <p className="text-ink-soft text-sm mt-1">Conduct expert interviews, launch coding assessments and submit evaluations.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: "Assigned", value: data.assigned.length },
          { label: "Completed", value: data.assigned.filter((i) => i.status === "completed").length },
          { label: "Avg Candidate Score", value: Math.round(data.assigned.filter((i) => i.overall).reduce((a, b) => a + b.overall, 0) / (data.assigned.filter((i) => i.overall).length || 1)) },
          { label: "Rating", value: "4.9" },
        ].map((k) => (
          <Card key={k.label} className="p-5"><div className="num font-bold text-3xl text-ink">{k.value}</div><div className="text-xs font-semibold text-ink-faint mt-0.5">{k.label}</div></Card>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        {data.assigned.map((iv) => {
          const meta = levelMeta(iv.status === "completed" ? iv.overall : null);
          return (
            <Card key={iv.id} className="p-5">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <span className="h-11 w-11 rounded-full bg-brand-light grid place-items-center"><User className="h-5 w-5 text-brand" /></span>
                  <div>
                    <div className="font-semibold text-ink">{iv.candidate_name}</div>
                    <div className="text-xs text-ink-faint">{iv.college_name || "Individual"}</div>
                  </div>
                </div>
                <span className="text-xs font-bold px-2.5 py-1 rounded-full" style={{ background: meta.bg, color: meta.text }}>{iv.status === "completed" ? iv.overall : "Scheduled"}</span>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
                <div><div className="text-[11px] text-ink-faint font-semibold uppercase">Role</div><div className="text-ink font-medium">{iv.role_name}</div></div>
                <div><div className="text-[11px] text-ink-faint font-semibold uppercase">Date</div><div className="text-ink font-medium num">{iv.date} · {iv.time}</div></div>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                <button className="inline-flex items-center gap-1.5 text-xs font-bold text-white bg-slate-900 hover:bg-slate-800 px-3.5 py-2 rounded-full transition-colors"><FileText className="h-3.5 w-3.5" /> Candidate Profile</button>
                <button className="inline-flex items-center gap-1.5 text-xs font-bold text-ink bg-slate-100 hover:bg-slate-200 px-3.5 py-2 rounded-full transition-colors"><Code2 className="h-3.5 w-3.5" /> Launch Coding</button>
                {iv.verification_id && <Link to={`/scorecard/${iv.verification_id}`} target="_blank" className="inline-flex items-center gap-1.5 text-xs font-bold text-brand bg-brand-light px-3.5 py-2 rounded-full transition-colors"><QrCode className="h-3.5 w-3.5" /> Scorecard</Link>}
              </div>
            </Card>
          );
        })}
        {!data.assigned.length && <Card className="p-10 text-center text-ink-soft lg:col-span-2">No interviews assigned yet.</Card>}
      </div>
    </div>
  );
}
